import { useCallback } from 'react';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';

const useNotistack = (text, type = 'success') => {
  const { enqueueSnackbar } = useSnackbar();
  // Memoised: `notify` used to be a new function on every render, so any effect that
  // listed it as a dependency re-ran on every render - one screen re-fetched a record
  // in a loop for as long as its window stayed open. enqueueSnackbar itself is stable.
  const notify = useCallback(
    (text, type = 'success') => enqueueSnackbar(text, { variant: type }),
    [enqueueSnackbar]
  );
  return { notify };
};

useNotistack.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info'])
};

export default useNotistack;
